import React from "react";

export default class MissionPrivacy extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const mission = this.props.mission;

        return (
            <React.Fragment>
                <h4 className="primary-color mb-0">MISSION PRIVACY</h4>
                <p>
                    Choose your mission privacy settings. These can be updated
                    at any time.
                </p>

                <div className="edit-mission-box mb-2 mt-0">
                    <label className="edit-mission-timeframe-radio">
						<div>
							<input
								type="radio"
								name="public"
								onChange={this.props.handleChange}
								value="3"
								checked={mission.public == "3" ? true : false}
								tabIndex="8"
								className="form-check-input"
							/>
						</div>
						<div className="ms-3">
							<h3>Public</h3>
							<p className="mb-0">
								Anyone can view your mission page, newsfeed and
								leaderboard. The mission will show in site search.
							</p>
						</div>
                    </label>
                </div>

                <div className="edit-mission-box">
                    <label className="edit-mission-timeframe-radio">
						<div>
							<input
								type="radio"
								name="public"
								onChange={this.props.handleChange}
								value="5"
								checked={mission.public == "5" ? true : false}
								tabIndex="9"
								className="form-check-input"
							/>
						</div>
						<div className="ms-3">
							<h3>Private</h3>
							<p className="mb-0">
								Only people who are on your mission can view your
								mission page, newsfeed and leaderboard. The mission
								will not show in site search. Anyone can apply to
								join the mission.
							</p>
						</div>
                    </label>
                </div>
            </React.Fragment>
        );
    }
}
